import React from 'react'
import AppendInput from '../../../../component/form/AppendInput';

function TotalBillFooter({ calculateTotalBill, error, additionDiscountAndTax, subTotal, setAdditionDiscountAndTax }) {

  return (
    <div
      style={{
        height: '200px',
        border: '1px solid #C3CBDC',
        backgroundColor: '#DADDEC',
        alignItems: 'center',
      }}
    >
      <div
        className="max-w-1297"
        style={{ padding: '1rem 2rem 0' }}
      >
        <div className="TotalBillDivCredit">
          <div style={{ textAlign: 'right' }}>
            <p style={{ marginBottom: '16px', marginTop: '10px' }}>Discount</p>
            <p>Sub Total</p>
            <p>Taxes</p>
            <p>Bill Total </p>
          </div>
          <div style={{ textAlign: 'left' }}>
            <p>
              <AppendInput
                label=""
                placeholder="0"
                appendLabel="%"
                type="text"
                className="custom-append-text"
                error={error?.payment_amount}
                value={additionDiscountAndTax?.discount}
                onChange={(valueData) => {
                  let value = valueData?.replace(/[^0-9.]/g, '');
                  const decimalCount = (value.match(/\./g) || []).length;
                  if (decimalCount > 1) {
                    value = +value?.slice(0, value.lastIndexOf('.'));
                  }
                  setAdditionDiscountAndTax((prev) => ({
                    ...prev,
                    discount: value,
                  }));
                }}
              />
            </p>
            <p>₹{subTotal.toFixed(2)}/-</p>
            <p>₹{additionDiscountAndTax.taxes.toFixed(2)}/-</p>
            <p>₹{calculateTotalBill().toFixed(2)}/-</p>
          </div>
        </div>
      </div>


    </div>
  )
}

export default TotalBillFooter